__turbopack_context__.v({
  "carListWrapper": "AoFQkW_carListWrapper",
  "carRentalWrapper": "AoFQkW_carRentalWrapper",
  "extraHintText": "AoFQkW_extraHintText",
});
